module.exports = __webpack_public_path__ + "static/media/statement-icon.117e66d6.svg";